
import React from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Coins, TestTube, AlertCircle } from "lucide-react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import CreditSwapForm from "./CreditSwapForm";
import UserReagentSelect from "./UserReagentSelect";
import { Reagent } from "@/services/reagentService";

interface OfferTypeTabsProps {
  offerType: "reagent" | "credits";
  onValueChange: (value: string) => void;
  creditAmount: number;
  setCreditAmount: (value: number) => void;
  userReagents: Reagent[];
  selectedReagentId: string | null;
  setSelectedReagentId: (id: string) => void;
  isLoadingReagents: boolean;
  insufficientCredits: boolean;
  creditBalance?: number;
}

const OfferTypeTabs: React.FC<OfferTypeTabsProps> = ({
  offerType,
  onValueChange,
  creditAmount,
  setCreditAmount,
  userReagents,
  selectedReagentId,
  setSelectedReagentId,
  isLoadingReagents,
  insufficientCredits,
  creditBalance = 0
}) => {
  return (
    <Tabs defaultValue={offerType} onValueChange={onValueChange}>
      <TabsList className="grid w-full grid-cols-2">
        <TabsTrigger value="credits" className="flex items-center gap-2">
          <Coins className="h-4 w-4" />
          <span>Swap with Credits</span>
        </TabsTrigger>
        <TabsTrigger value="reagent" className="flex items-center gap-2">
          <TestTube className="h-4 w-4" />
          <span>Swap with Reagent</span>
        </TabsTrigger>
      </TabsList>
      
      <TabsContent value="credits" className="mt-4">
        <CreditSwapForm 
          creditAmount={creditAmount} 
          setCreditAmount={setCreditAmount} 
        />
        
        {insufficientCredits && (
          <Alert variant="destructive" className="mt-4">
            <AlertCircle className="h-4 w-4" />
            <AlertTitle>Insufficient Credits</AlertTitle>
            <AlertDescription>
              You don't have enough credits for this swap. You have {creditBalance} credits available.
            </AlertDescription>
          </Alert>
        )}
      </TabsContent>
      
      <TabsContent value="reagent" className="mt-4">
        <UserReagentSelect
          userReagents={userReagents}
          selectedReagentId={selectedReagentId}
          setSelectedReagentId={setSelectedReagentId}
          isLoading={isLoadingReagents}
        />
      </TabsContent>
    </Tabs>
  );
};

export default OfferTypeTabs;
